export const getFooterBannersSuccess = (list = []) => {
    return {
      type : 'GET_FOOTER_BANNERS_SUCCESS',
      payload: list 
    }
  };
  